import get from 'lodash/get';
export { collectionToStories } from '@quintype/components';


export function collectionColor(config, collection) {
  const sectionId = collection.template == 'section' ? get(collection.metadata, ["section", "id"]) || get(collection.metadata, ["section", 0, "id"]) : null;
  const menuItem = config.layout.menu.find(menuItem => menuItem.type == 'section' && menuItem['item-id'] == sectionId);
  return get(menuItem, ["data", "color"], '#6093f2');
}

export function collectionSection(config, collection) {
  const sectionId = collection.template == 'section' ? get(collection.metadata, ["section", "id"]) || get(collection.metadata, ["section", 0, "id"]) : null;
  return config.sections.find(section => section.id == sectionId);
}
